import pic1 from '../../images/Night3.jpg';
import pic2 from '../../images/Night1.jpg';
import pic3 from '../../images/Pool5.jpg';
import pic4 from '../../images/Kitchen1.jpg';
import pic5 from '../../images/Garage2.jpg';
import pic6 from '../../images/Media1.jpg';


export const images = [
    {
      original: pic1
    },
    {
      original: pic2
    },
    {
      original: pic3
    },
    {
      original: pic4
    },
    {
      original: pic5
    },
    {
      original: pic6
    }
  ];

